import { resolveApiUrl } from "~/utils/url/urlResolver";

const API_URL = resolveApiUrl("/api/fcc/graphs");

export interface TrainDetailsDTO {
  avgRlt?: number;
  avgPerMonthPcs?: number;
  validFrom?: number;
  validTo?: number;
  salesCoverage?: Record<CoverageType, Record<CoverageUnit, SalesCoverageDTO>>;
}

export type CoverageType = "CUSTOMER_CATALOG" | "FCC_CATALOG_ONLY";
export type CoverageUnit = "EURO" | "PIECES";

export interface SalesCoverageDTO {
  ytdSales?: number;
  orderbook?: number;
  gap?: number;
  plan?: number;
  budget?: number;
}

interface Params {
  fifteenDigit?: string;
  productLine?: string;
  trainId?: string;
}

export async function fetchTrainDetails(data: Params, abortSignal?: AbortSignal): Promise<TrainDetailsDTO> {
  const params = new URLSearchParams();
  if (data.fifteenDigit) {
    params.set("fifteenDigit", data.fifteenDigit);
  }
  if (data.productLine) {
    params.set("productLine", data.productLine);
  }
  if (data.trainId) {
    params.set("trainId", data.trainId);
  }

  const response = await fetch(API_URL + "?" + params.toString(), {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    signal: abortSignal,
  });

  if (response.redirected) {
    window.location.reload();
  }

  if (!response.ok) {
    throw new Error("Error fetching search results");
  }

  return response.json();
}
